import { LandingTemplate } from "@/components/LandingTemplate";

export default function AiCvBuilderPage() {
  return (
    <LandingTemplate
      testid="cv-landing"
      eyebrow="AI CV Builder"
      h1="Free AI CV Builder UK — An ATS-Friendly CV in 60 Seconds"
      sub="Answer a few questions and Zuntria's AI writes a professional, ATS-friendly CV tailored to the exact job you want — care worker, cleaner, security, hospitality, admin, tech and more. Download as PDF or DOCX and apply today."
      cta="Build my CV free"
      ctaTo="/signup"
      bullets={[
        { title: "ATS-friendly by default", text: "Clean structure, standard headings and no gimmicks — so recruiter software actually reads your CV." },
        { title: "Tailored to the job", text: "Tell the AI your target role and it writes your experience in the language UK employers search for." },
        { title: "PDF & DOCX export", text: "Download in the formats every UK job board accepts, then continue straight to LinkedIn, Indeed or Reed." },
        { title: "Multiple CV versions", text: "Keep separate CVs for different roles — construction, cleaning, hospitality, tech — and never overwrite one by accident." },
      ]}
      steps={[
        "Create a free account and open the CV Builder.",
        "Enter your target role, experience and skills — AI does the writing.",
        "Review and edit your ATS-friendly CV.",
        "Download PDF/DOCX and continue to a job board pre-searched for your role.",
      ]}
      faqs={[
        { q: "Is the AI CV builder really free?", a: "Yes — building and previewing your CV is free. Downloading polished PDF/DOCX files is part of Zuntria Pro from £14.99/month, and you can copy your CV text free at any time." },
        { q: "What makes a CV ATS-friendly?", a: "Applicant Tracking Systems prefer single-column layouts, standard section headings (Work Experience, Education, Skills), no tables or graphics, and keywords that match the job description. Zuntria's AI builds all of this in automatically." },
        { q: "Can it write a CV for a care worker or cleaner with no formal experience?", a: "Yes — the AI turns everyday responsibilities, volunteering and transferable skills into professional CV language that UK employers recognise, even if this is your first formal role." },
        { q: "Which job boards can I apply on?", a: "After downloading, Zuntria links you straight to LinkedIn, Indeed, Reed, TotalJobs and Contra, pre-searched for your target role — then tracks every application in your free Job Tracker." },
        { q: "Does it work for cover letters too?", a: "Yes — Zuntria also has an AI letter builder for cover letters, landlord letters and formal correspondence." },
      ]}
    />
  );
}
